import superMeta from '../_CAT_ROOT_MODULE/metaCatRootModuleNode.mjs'

export default {
    ...superMeta,
    moduleIdProp: 'pmId',
    moduleType: 'PM',
    name: '知识模块',
    type: 'CAT_ROOT_PM',
}
